import { HttpEvent, HttpHandler, HttpInterceptor, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { ApplicationRef, Injectable, NgZone } from '@angular/core';
import { finalize, Observable } from 'rxjs';

/* export const changeDetectionInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req);
}; */
@Injectable()
export class ChangeDetectionInterceptor implements HttpInterceptor {
  constructor(private appRef : ApplicationRef, private zone : NgZone) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return new Observable<HttpEvent<any>>(observer => {
      this.zone.run(() => {
        next.handle(req).subscribe({
          next : (res) => this.zone.run(() => observer.next(res)),
          error : (err) => this.zone.run(() => { observer.error(err); this.refreshView(); }),
          complete : () => this.zone.run(() => { observer.complete(); this.refreshView(); })
        })
      });
    })
  }

  private refreshView() {
    Promise.resolve().then(() => {
      try {
        this.appRef.tick();
      } catch (e) { }
    });
  }
}